import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Input } from "../components/ui/input";
import { Lock } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const res = await axios.post(`${API}/auth/login`, { email, password });
            localStorage.setItem("pepstep_admin_token", res.data.token);
            toast.success("Welcome back");
            navigate("/admin");
        } catch (err) {
            toast.error("Invalid credentials");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="pt-32 pb-24 min-h-screen flex items-center" data-testid="admin-login-page">
            <div className="max-w-md mx-auto w-full px-6">
                <form onSubmit={submit} className="bg-white rounded-3xl border border-pep-border/50 p-8 md:p-10">
                    <div className="w-12 h-12 rounded-2xl bg-pep-primary text-white flex items-center justify-center mb-6">
                        <Lock className="w-5 h-5" />
                    </div>
                    <h1 className="font-heading text-3xl text-pep-navy font-medium mb-2">Admin sign in</h1>
                    <p className="text-pep-muted text-sm mb-8">Sign in to manage products and orders.</p>

                    <div className="space-y-4">
                        <div>
                            <label className="text-sm text-pep-navy font-medium mb-1.5 block">Email</label>
                            <Input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="orders@pepstep.com"
                                className="rounded-xl border-pep-border"
                                data-testid="admin-login-email"
                            />
                        </div>
                        <div>
                            <label className="text-sm text-pep-navy font-medium mb-1.5 block">Password</label>
                            <Input
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="rounded-xl border-pep-border"
                                data-testid="admin-login-password"
                            />
                        </div>
                        <button
                            type="submit"
                            disabled={loading}
                            className="w-full bg-pep-primary text-white rounded-full py-3.5 font-medium hover:bg-pep-navy transition disabled:opacity-50"
                            data-testid="admin-login-submit"
                        >
                            {loading ? "Signing in..." : "Sign In"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
